<div class="card bg-light mb-3" style="max-width: 18rem;">
  <!--<div class="card-header">Header</div>-->
  <div class="card-body">
    <!--<h5 class="card-title">Light card title</h5>-->
    <ng-content></ng-content>
    <!--<p class="card-text">
    </p>-->
  </div>
</div>
